import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IDatabaseContactParams {
    contactId: string;
    contactType: string;
    ids: string[];
}

export class SetDatabasesContactRequest extends Request<IDatabaseContactParams, IResult> {
    constructor(params: IDatabaseContactParams) {
      super('setDatabasesContact', params);
    }
  }
